import moment from "moment";
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { headers, insertDelegateInvitationAllocationUrl, getDelegateInvitationAllocationListUrl, INSERT_UPDATE_DELEGATE_INVITATION_ALLOCATION_ACTION_TYPE, GET_DELEGATE_INVITATION_ALLOCATION_ACTION_TYPE } from "../../../utils/constants";


export const insertUpdate_InvitationAllocation_action = (ExhibitionID, InvitationEventList, ScheduleInvitationID, ScheduleDate, ScheduleTime) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            InvitationEventList: InvitationEventList,
            ScheduleInvitationID: ScheduleInvitationID,
            ScheduleDate: ScheduleDate,
            ScheduleTime: ScheduleTime,
        }

        const res = await axiosPost(insertDelegateInvitationAllocationUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_DELEGATE_INVITATION_ALLOCATION_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getInvitationAllocation_action = (ExhibitionID, InvitationEventList, Designation, CompanyName, CountryName, EmailID, Name) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            InvitationEventList: InvitationEventList,
            Designation: Designation,
            CompanyName: CompanyName,
            CountryName: CountryName,
            EmailID: EmailID,
            Name: Name,
        }

        const res = await axiosPost(getDelegateInvitationAllocationListUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_INVITATION_ALLOCATION_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}